<template>
    <div>
        <form-wizard
            ref="wizzard"
            shape="circle"
            color="#1C3D5A"
            error-color="#c60108"
            step-size="sm"
        >
            <div slot="title"></div>

            <tab-content
                title="Sucursal, Moto y Servicios"
                xicon="fal fa-cogs"
                :before-change="validarMotoServicios"
            >
                <!-- Región y Distribuidor -->
                <div class="w-full flex flex-wrap mb-2">
                    <div class="w-full md:w-1/2 mb-6 px-3">
                        <label
                            for="cmbRegiones"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Región
                        </label>
                        <div class="relative">
                            <select
                                id="cmbRegiones"
                                name="region_id"
                                v-model="form.region_id"
                                @change="cambiarRegion()"
                                autocomplete="chrome-off"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-600':
                                        elementHasError('tab-2', 'region_id'),
                                }"
                                class="block rounded-none appearance-none w-full text-gray-700 bg-white border-b border-gray py-3 px-4 pr-8 leading-tight focus:outline-none"
                            >
                                <option
                                    v-for="region in regiones"
                                    :key="region.id"
                                    :value="region.id"
                                >
                                    {{ region.nombre }}
                                </option>
                            </select>
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                            >
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2 mb-6 px-3">
                        <label
                            for="cmbDistribuidores"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Distribuidor
                        </label>
                        <div class="relative">
                            <select
                                id="cmbDistribuidores"
                                name="distribuidor_id"
                                v-model="form.distribuidor_id"
                                @change="cambiarDistribuidor()"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-600':
                                        elementHasError(
                                            'tab-2',
                                            'distribuidor_id'
                                        ),
                                }"
                                class="block rounded-none appearance-none w-full text-gray-700 bg-white border-b border-gray py-3 px-4 pr-8 leading-tight focus:outline-none"
                            >
                                <option
                                    v-for="d in distribuidores"
                                    :key="d.id"
                                    :value="d.id"
                                >
                                    {{ `${d.nombre} (${d.ciudad})` }}
                                </option>
                            </select>
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                            >
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Datos de la moto -->
                <div class="w-full flex flex-wrap mb-2">
                    <div class="w-full md:w-1/5 mb-4 px-3">
                        <label
                            for="cmbMotos"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Modelo <span class="required">*</span>
                        </label>
                        <div class="relative">
                            <select
                                id="cmbMotos"
                                name="moto_id"
                                v-model="form.moto_id"
                                @change="cambiarMoto()"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-700':
                                        elementHasError('tab-1', 'moto_id'),
                                }"
                                class="block rounded-none appearance-none w-full text-gray-700 bg-white border-b border-gray py-3 px-4 pr-8 leading-tight focus:outline-none"
                            >
                                <optgroup
                                    v-for="categoria in ordenarCategorias(
                                        categorias
                                    )"
                                    :key="categoria.id"
                                    :label="categoria.nombre"
                                >
                                    <option
                                        v-for="moto in categoria.motos"
                                        :key="moto.id"
                                        :value="moto.id"
                                    >
                                        {{ moto.modelo }}
                                    </option>
                                </optgroup>
                            </select>
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                            >
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/5 mb-4 px-3">
                        <label
                            for="patente"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Patente <span class="required">*</span>
                        </label>
                        <input
                            type="text"
                            id="patente"
                            name="patente"
                            v-model="form.patente"
                            maxlength="6"
                            placeholder="ABC123"
                            @keyup="clearElementError('tab-1', 'patente')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-1', 'patente'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/5 mb-4 px-3">
                        <label
                            for="chasis"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Nº Chasis
                        </label>
                        <input
                            type="text"
                            id="chasis"
                            name="chasis"
                            v-model="form.chasis"
                            placeholder="XXXXXX0X000001234"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/5 mb-4 px-3">
                        <label
                            for="anio"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Año <span class="required">*</span>
                        </label>
                        <input
                            type="number"
                            id="anio"
                            name="anio"
                            v-model="form.anio"
                            :placeholder="new Date().getFullYear()"
                            :max="new Date().getFullYear()"
                            min="1900"
                            @keyup="clearElementError('tab-1', 'anio')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-1', 'anio'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/5 mb-4 px-3">
                        <label
                            for="kilometraje"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Kilometraje <span class="required">*</span>
                        </label>
                        <input
                            type="number"
                            id="kilometraje"
                            name="kilometraje"
                            v-model="form.kilometraje"
                            placeholder="10000"
                            @keyup="clearElementError('tab-1', 'kilometraje')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-1', 'kilometraje'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full mb-4 px-3" v-if="esPresupuestoQuery">
                        <label
                            for="comentarios"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Comentarios
                        </label>
                        <textarea
                            id="comentarios"
                            name="comentarios"
                            v-model="form.comentarios"
                            placeholder="Comentarios u observaciones adicionales..."
                            @keyup="clearElementError('tab-1', 'comentarios')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-1', 'comentarios'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        ></textarea>
                    </div>
                    <div class="w-full mb-6">
                        <span class="text-xs text-gray-500"
                            >* campos requeridos</span
                        >
                    </div>
                </div>
                <!-- Servicios -->
                <div class="w-full flex flex-wrap mb-2">
                    <div class="w-full mb-6 px-3" v-show="servicios.length > 0">
                        <label
                            for="c-servicios"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Servicios disponibles
                        </label>
                        <div id="c-servicios" class="flex flex-wrap">
                            <div
                                :class="{
                                    'bg-red-100 border-red-600':
                                        elementHasError('tab-1', 'servicios'),
                                }"
                                class="flex flex-wrap content-start w-full md:w-1/2 border border-transparent bg-gray-100 p-4"
                            >
                                <div
                                    v-for="servicio in servicios"
                                    :key="servicio.id"
                                    class="text-gray-700 mb-2 mr-8 w-full md:w-2/5"
                                    @click="agregarServicio(servicio, $event)"
                                >
                                    <pretty-radio
                                        class="w-full leading-tight p-default p-smooth text-sm"
                                        color="info"
                                        :id="'servicio-' + servicio.id"
                                        name="servicios[]"
                                        :value="servicio.id"
                                        >{{ servicio.nombre }}</pretty-radio
                                    >
                                </div>
                            </div>
                            <div
                                class="w-full md:w-1/2 border border-transparent bg-gray-100 p-4"
                            >
                                <div
                                    v-show="form.servicios.length > 0"
                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                >
                                    <span v-show="!this.esPresupuestoQuery"
                                        >Incluye *</span
                                    >
                                    <span v-show="this.esPresupuestoQuery"
                                        >Importante *</span
                                    >
                                </div>
                                <div
                                    class="text-sm text-gray-700"
                                    v-if="form.servicios.length > 0"
                                >
                                    <ul class="list-disc ml-4 mb-4">
                                        <li
                                            v-for="(
                                                incluye, index
                                            ) in listaIncluye"
                                            :key="index"
                                        >
                                            {{ incluye }}
                                        </li>
                                    </ul>
                                    <span
                                        class="text-xs text-gray-600"
                                        v-show="!this.esPresupuestoQuery"
                                        >* Valores incluyen exclusivamente lo
                                        detallado en mantención seleccionada y
                                        no otros servicios o requerimientos.
                                        Valores inlcuyen IVA.
                                    </span>
                                    <span
                                        class="text-xs text-gray-600"
                                        v-show="this.esPresupuestoQuery"
                                    >
                                        * Valores inlcuyen IVA.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="flex flex-col justify-center items-end w-full border border-transparent bg-gray-300 p-4"
                        >
                            <!--
                            <div
                                v-show="!esPresupuesto"
                                class="uppercase text-xs text-blue-800 font-bold"
                            >
                                Duración estimada
                            </div>
                            <div
                                v-show="!esPresupuesto"
                                class="text-blue-900 text-xl font-bold"
                            >
                                {{ duracionTotal }} h
                            </div>
                            -->
                            <div class="mt-2 text-xs text-blue-800 font-bold">
                                <span class="uppercase mr-1">Total</span>
                                <span class="font-normal">(IVA Incl.)</span>
                            </div>
                            <div
                                class="uppercase text-blue-900 text-xl font-bold"
                            >
                                ${{ precioTotal | prettyNumber }}
                            </div>
                        </div>
                    </div>
                </div>
            </tab-content>

            <tab-content
                title="Fecha y hora"
                xicon="fal fa-calendar-alt"
                :before-change="validarFechaReserva"
            >
                <div class="w-full flex flex-wrap mb-2">
                    <div class="flex flex-col w-full md:w-1/2 mb-6 px-3">
                        <label
                            for="FechaDatePicker"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Fecha de la reserva
                        </label>
                        <vue-ctk-date-time-picker
                            id="FechaDatePicker"
                            class="datepicker-reserva"
                            v-model="form.fecha_reserva"
                            :class="{
                                'border border-red-600 rounded-none':
                                    elementHasError('tab-2', 'fecha_reserva'),
                            }"
                            color="#2679bd"
                            input-size="md"
                            label=""
                            hint=""
                            :inline="true"
                            :no-header="true"
                            :no-keyboard="true"
                            :no-button-now="true"
                            format="DD-MM-YYYY"
                            formatted="ll"
                            :disabled-weekly="datepicker.disabledWeekly"
                            :only-date="true"
                            :min-date="minDate"
                        />
                    </div>
                    <div class="flex flex-col w-full md:w-1/2 mb-6 px-3">
                        <label
                            for="HoraDatePicker"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Hora de la reserva
                        </label>
                        <div
                            id="HoraDatePicker"
                            v-if="datepicker.enabledHours.length > 0"
                            class="py-2 flex-1"
                            :class="{
                                'text-red-600': elementHasError(
                                    'tab-2',
                                    'hora_reserva'
                                ),
                            }"
                        >
                            <div
                                v-for="(h, index) in datepicker.enabledHours"
                                :key="index"
                            >
                                <pretty-radio
                                    v-model="form.hora_reserva"
                                    class="leading-tight p-default p-smooth"
                                    color="info"
                                    name="hora_disponible"
                                    :value="h"
                                >
                                    <span class="text-sm">{{
                                        h.substring(0, 5) + " hrs."
                                    }}</span>
                                </pretty-radio>
                            </div>
                        </div>
                        <div class="flex-1" v-else>
                            <small
                                :class="{
                                    'text-red-600': elementHasError(
                                        'tab-2',
                                        'hora_reserva'
                                    ),
                                }"
                            >
                                <i class="fal fa-fw fa-exclamation-circle"></i>
                                Sin horarios disponibles
                            </small>
                        </div>
                    </div>
                </div>
            </tab-content>

            <tab-content
                title="Información personal"
                xicon="fal fa-user"
                :before-change="validarDatosPersonales"
            >
                <div class="w-full flex flex-wrap mb-2">
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="nombre"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Nombre
                        </label>
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            v-model="form.nombre"
                            @keyup="clearElementError('tab-3', 'nombre')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-3', 'nombre'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="apellido"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Apellido
                        </label>
                        <input
                            type="text"
                            id="apellido"
                            name="apellido"
                            v-model="form.apellido"
                            @keyup="clearElementError('tab-3', 'apellido')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-3', 'apellido'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="rut"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            RUT
                        </label>
                        <input
                            type="text"
                            id="rut"
                            name="rut"
                            v-model="form.rut"
                            maxlength="10"
                            placeholder="12345678-9"
                            @keyup="limpiarRut($event)"
                            @change="clearElementError('tab-3', 'rut')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-3', 'rut'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="email"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            E-mail
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            v-model="form.email"
                            placeholder="correo@dominio.com"
                            @keyup="clearElementError('tab-3', 'email')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-3', 'email'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="cmbRegionesCliente"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Región
                        </label>
                        <div class="relative">
                            <select
                                id="cmbRegionesCliente"
                                name="region_id_cliente"
                                v-model="form.region_id_cliente"
                                @change="cambiarRegionCliente()"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-700':
                                        elementHasError(
                                            'tab-3',
                                            'region_id_cliente'
                                        ),
                                }"
                                class="block rounded-none appearance-none w-full text-gray-700 bg-white border-b border-gray py-3 px-4 pr-8 leading-tight focus:outline-none"
                            >
                                <option
                                    v-for="region in regiones"
                                    :key="region.id"
                                    :value="region.id"
                                >
                                    {{ region.nombre }}
                                </option>
                            </select>
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                            >
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="cmbComunas"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Comuna
                        </label>
                        <div class="relative">
                            <select
                                id="cmbComunas"
                                name="moto_id"
                                v-model="form.comuna_id"
                                @change="cambiarComuna()"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-700':
                                        elementHasError('tab-3', 'comuna_id'),
                                }"
                                class="block rounded-none appearance-none w-full text-gray-700 bg-white border-b border-gray py-3 px-4 pr-8 leading-tight focus:outline-none"
                            >
                                <option
                                    v-for="comuna in comunas"
                                    :key="comuna.id"
                                    :value="comuna.id"
                                >
                                    {{ comuna.nombre }}
                                </option>
                            </select>
                            <div
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                            >
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="direccion"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Dirección
                        </label>
                        <input
                            type="text"
                            id="direccion"
                            name="direccion"
                            v-model="form.direccion"
                            @keyup="clearElementError('tab-3', 'direccion')"
                            :class="{
                                'bg-red-100 border-red-600 text-red-700':
                                    elementHasError('tab-3', 'direccion'),
                            }"
                            class="appearance-none block w-full text-gray-700 bg-white border-b border-gray py-3 px-4 leading-tight focus:outline-none"
                        />
                    </div>
                    <div class="w-full md:w-1/2 px-3 mb-6">
                        <label
                            for="telefono"
                            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        >
                            Teléfono
                        </label>
                        <div
                            class="flex flex-wrap items-stretch w-full mb-4 relative"
                        >
                            <div class="flex -mr-px">
                                <span
                                    class="flex items-center leading-tight bg-gray-200 border-b border-gray py-3 px-4 whitespace-no-wrap text-gray-700 text-sm"
                                >
                                    +56
                                </span>
                            </div>
                            <input
                                type="number"
                                id="telefono"
                                name="telefono"
                                v-model="form.telefono"
                                maxlength="9"
                                placeholder="9 xxxx xxxx"
                                @keyup="clearElementError('tab-3', 'telefono')"
                                :class="{
                                    'bg-red-100 border-red-600 text-red-700':
                                        elementHasError('tab-3', 'telefono'),
                                }"
                                class="appearance-none flex-shrink flex-grow flex-auto flex-1 w-px block text-gray-700 bg-white border-b border-gray py-3 px-4 relative leading-tight focus:outline-none"
                            />
                        </div>
                    </div>
                </div>
            </tab-content>

            <tab-content title="Resumen" xicon="fal fa-file-alt">
                <div class="flex flex-wrap">
                    <!-- Cuándo -->
                    <div
                        class="flex flex-col w-full lg:w-1/4 mb-4 pr-0 lg:pr-2"
                    >
                        <div class="bg-gray-100 py-2 px-2">
                            <p
                                class="uppercase text-sm font-light text-gray-800"
                            >
                                Cuándo
                            </p>
                        </div>
                        <div
                            class="p-4 flex flex-col leading-normal text-gray-800"
                        >
                            <!-- Calendario -->
                            <div
                                class="min-w-32 bg-white min-h-48 p-3 mb-4 font-medium m-auto"
                            >
                                <div
                                    class="w-32 flex-none rounded-t lg:rounded-t-none lg:rounded-l text-center shadow"
                                >
                                    <div
                                        class="block rounded-t overflow-hidden text-center"
                                    >
                                        <div
                                            class="bg-blue-600 text-white py-1 uppercase"
                                        >
                                            {{
                                                (form.fecha_reserva
                                                    ? parseDate(
                                                          form.fecha_reserva
                                                      )
                                                    : "") | formatDate("MMMM")
                                            }}
                                        </div>
                                        <div
                                            class="pt-1 border-l border-r border-white bg-white"
                                        >
                                            <span
                                                class="text-5xl font-bold leading-tight"
                                                >{{
                                                    (form.fecha_reserva
                                                        ? parseDate(
                                                              form.fecha_reserva
                                                          )
                                                        : "") | formatDate("DD")
                                                }}</span
                                            >
                                        </div>
                                        <div
                                            class="border-l border-r border-b rounded-b-lg text-center border-white bg-white -pt-2 -mb-1"
                                        >
                                            <span class="text-sm">
                                                {{
                                                    (form.fecha_reserva
                                                        ? parseDate(
                                                              form.fecha_reserva
                                                          )
                                                        : "")
                                                        | formatDate("dddd")
                                                }}
                                            </span>
                                        </div>
                                        <div
                                            class="pb-2 border-l border-r border-b rounded-b-lg text-center border-white bg-white"
                                        >
                                            <span
                                                class="text-xs leading-normal"
                                            >
                                                {{
                                                    form.hora_reserva
                                                        ? form.hora_reserva.substring(
                                                              0,
                                                              5
                                                          ) + " hrs"
                                                        : ""
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Distribuidor y Dirección -->
                            <div class="text-sm font-semibold text-gray-700">
                                {{
                                    form.distribuidor
                                        ? form.distribuidor.nombre
                                        : ""
                                }}
                            </div>
                            <div class="mt-1 text-sm font-light">
                                {{
                                    form.distribuidor
                                        ? form.distribuidor.direccion
                                        : "-"
                                }}
                                <span class="block">
                                    {{
                                        form.distribuidor
                                            ? form.distribuidor.ciudad +
                                              (form.region &&
                                              form.region.id === 13
                                                  ? ", Santiago"
                                                  : ", " +
                                                    (form.region
                                                        ? form.region.nombre
                                                        : ""))
                                            : ""
                                    }}
                                </span>
                            </div>
                            <button
                                @click="abrirModal('modalMapa')"
                                class="w-full md:w-auto border border-blue-600 text-blue-600 hover:border-blue-600 hover:bg-blue-600 hover:text-white uppercase py-3 px-5 mt-4 mb-4 focus:outline-none focus:shadow-outline"
                            >
                                <!--i class="fal fa-fw fa-map"></i-->
                                Ver mapa
                            </button>
                        </div>
                    </div>
                    <!-- Moto, Cliente y Servicios -->
                    <div class="flex flex-col flex-wrap w-full lg:w-3/4">
                        <!-- Servicios -->
                        <div class="flex flex-col w-full lg:flex-1 mr-0 mb-4">
                            <div
                                class="flex flex-wrap justify-between bg-gray-100 py-2 px-2"
                            >
                                <div
                                    class="uppercase text-sm font-light text-gray-800"
                                >
                                    Servicio solicitado
                                </div>
                                <div class="text-sm font-light text-gray-800">
                                    <!--
                                    <span v-show="!esPresupuesto">
                                        Duración:
                                        <span class="font-bold"
                                            >{{ duracionTotal }} h</span
                                        >
                                    </span>
                                    / -->
                                    Total:
                                    <span class="font-bold"
                                        >${{ precioTotal | prettyNumber }}
                                        <small>IVA incl.</small></span
                                    >
                                </div>
                            </div>
                            <div class="px-4 pt-4 flex">
                                <ul
                                    class="list-reset leading-normal text-gray-800"
                                >
                                    <li
                                        v-for="servicio in form.servicios"
                                        :key="servicio.id"
                                    >
                                        <pretty-check
                                            class="leading-tight p-default p-smooth p-locked"
                                            color="info"
                                            checked="true"
                                        >
                                            <span class="text-sm">{{
                                                servicio.nombre
                                            }}</span>
                                        </pretty-check>
                                    </li>
                                </ul>
                            </div>
                            <div
                                class="px-4 py-4 w-full text-xs text-gray-700"
                                v-if="form.servicios.length > 0"
                            >
                                <ul
                                    class="flex flex-col md:flex-row flex-wrap list-disc pl-4"
                                >
                                    <li
                                        class="pr-4 mr-2"
                                        v-for="(incluye, index) in listaIncluye"
                                        :key="index"
                                    >
                                        <span>{{ incluye }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="my-4">
                                <div
                                    class="m-auto w-full bg-orange-100 border-t-4 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                                    role="alert"
                                >
                                    <div class="flex">
                                        <div class="py-1">
                                            <svg
                                                class="fill-current h-6 w-6 text-orange-500 mr-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                                                />
                                            </svg>
                                        </div>
                                        <div>
                                            <p class="font-bold">Importante</p>
                                            <p class="text-sm">
                                                El horario de entrega queda
                                                sujeto a disponibilidad y se
                                                coordinará con el asesor de
                                                servicio.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Datos de la Moto y del Cliente -->
                        <div class="flex flex-wrap mb-4 mr-0 lg:mr-2">
                            <!-- Datos de la Moto -->
                            <div
                                class="flex flex-col w-full lg:flex-1 mr-0 mb-4"
                            >
                                <div class="bg-gray-100 py-2 px-2">
                                    <p
                                        class="uppercase text-sm font-light text-gray-800"
                                    >
                                        Datos de la moto
                                    </p>
                                </div>
                                <div class="px-4 pt-4 flex">
                                    <div
                                        class="flex flex-col leading-normal text-gray-800"
                                    >
                                        <div
                                            class="text-lg font-semibold text-gray-700"
                                        >
                                            {{
                                                form.moto
                                                    ? form.moto.modelo
                                                    : ""
                                            }}
                                        </div>
                                        <div class="mb-1 text-sm font-light">
                                            <i
                                                class="fal fa-motorcycle fa-fw text-gray-600"
                                            ></i>
                                            Patente {{ form.patente }}
                                        </div>
                                        <div class="mb-1 text-sm font-light">
                                            <i
                                                class="fal fa-barcode-alt fa-fw text-gray-600"
                                            ></i>
                                            Chasis Nº {{ form.chasis }}
                                        </div>
                                        <div class="mb-1 text-sm font-light">
                                            <i
                                                class="fal fa-tag fa-fw text-gray-600"
                                            ></i>
                                            Año {{ form.anio }}
                                        </div>

                                        <div class="mb-1 text-sm font-light">
                                            <i
                                                class="fal fa-tachometer-alt-fast fa-fw text-gray-600"
                                            ></i>
                                            Kilometraje
                                            {{
                                                form.kilometraje | prettyNumber
                                            }}
                                        </div>
                                        <div
                                            class="mb-1 text-sm font-light"
                                            v-if="
                                                form.comentarios &&
                                                form.comentarios.length > 0
                                            "
                                        >
                                            <i
                                                class="fal fa-comments fa-fw text-gray-600"
                                            ></i>
                                            {{ form.comentarios }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Datos del Cliente -->
                            <div
                                class="flex flex-col w-full lg:flex-1 mr-0 mb-4"
                            >
                                <div class="bg-gray-100 py-2 px-2">
                                    <p
                                        class="uppercase text-sm font-light text-gray-800"
                                    >
                                        Datos del cliente
                                    </p>
                                </div>
                                <div
                                    class="p-4 flex flex-col leading-normal text-gray-800"
                                >
                                    <div
                                        class="text-lg font-semibold text-gray-700"
                                    >
                                        {{ form.nombre + " " + form.apellido }}
                                    </div>
                                    <div class="mt-1 text-sm font-light">
                                        <i
                                            class="fal fa-id-card fa-fw text-gray-600"
                                        ></i>
                                        {{ form.rut }}
                                    </div>
                                    <div class="mt-1 text-sm font-light">
                                        <i
                                            class="fal fa-at fa-fw text-gray-600"
                                        ></i>
                                        {{ form.email }}
                                    </div>
                                    <span class="mt-1 text-sm font-light">
                                        <i
                                            class="fal fa-map-marked-alt fa-fw text-gray-600"
                                        ></i>
                                        {{
                                            form.direccion + ", " + form.comuna
                                        }}
                                    </span>
                                    <span class="mt-1 text-sm font-light">
                                        <i
                                            class="fal fa-phone fa-fw text-gray-600"
                                        ></i>
                                        {{ form.telefono }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="text-xs text-justify text-gray-700">
                        Mediante el presente autorizo a YAMAIMPORT. a tratar mi
                        información con la red de atención de la marca, para
                        marca, para recibir información con relación al
                        producto, relativo a la post venta, como campañas de
                        campañas de recalls y marketing. Declaro que he sido
                        informado acerca del propósito del almacenamiento de mis
                        datos personales contenidos en el presente instrumento y
                        autorizo su tratamiento de conformidad lo regula la Ley
                        19.628 de Protección de Datos de Carácter Personal.
                    </p>
                </div>
            </tab-content>

            <template slot="footer" slot-scope="slotProps">
                <div class="wizard-footer-left">
                    <button
                        v-if="slotProps.activeTabIndex > 0"
                        class="ml-3 md:w-auto bg-white text-blue-600 border border-white hover:border-blue-600 uppercase py-3 px-5 mb-4 focus:outline-none"
                        @click="slotProps.prevTab()"
                    >
                        <i class="fal fa-fw fa-arrow-left"></i> Atrás
                    </button>
                </div>
                <div class="wizard-footer-right">
                    <button
                        v-if="!slotProps.isLastStep"
                        class="mr-3 md:w-auto bg-white bg-blue-600 hover:bg-blue-800 text-white uppercase py-3 px-5 mb-4 focus:outline-none"
                        @click="slotProps.nextTab()"
                    >
                        Siguiente <i class="fal fa-fw fa-arrow-right"></i>
                    </button>
                    <button
                        v-else
                        class="mr-3 md:w-auto bg-blue-600 hover:bg-blue-800 text-white uppercase py-3 px-5 mb-4 focus:outline-none"
                        @click="agendarReserva"
                    >
                        Agendar
                    </button>
                </div>
            </template>
        </form-wizard>

        <div class="mb-6" v-show="errors.response">
            <div
                class="m-auto max-w-md bg-orange-100 border-t-4 border-orange-500 rounded-b text-orange-900 px-4 py-3"
                role="alert"
            >
                <div class="flex">
                    <div class="py-1">
                        <svg
                            class="fill-current h-6 w-6 text-orange-500 mr-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                        >
                            <path
                                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                            />
                        </svg>
                    </div>
                    <div>
                        <p class="font-bold">
                            Ups, no pudimos procesar la solicitud.
                        </p>
                        <p class="text-sm">{{ errors.response }}</p>
                    </div>
                </div>
            </div>
        </div>

        <sweet-modal ref="modalMapa">
            <div v-if="form.distribuidor" v-html="iframeHtml"></div>
        </sweet-modal>

        <sweet-modal ref="modalReservaCreada" icon="success" :blocking="true">
            <div v-if="reserva" class="text-normal mt-8 p-4">
                <p class="my-4">
                    La reserva ha sido creada con el código
                    <strong>{{ reserva.id }}</strong> para el día
                    <strong>{{ form.fecha_reserva }}</strong> a las
                    <strong>{{ form.hora_reserva }}</strong
                    >.
                </p>
                <p class="my-4">
                    Adicionalmente se ha enviado el detalle de la reserva al
                    correo electrónico proporcionado.
                </p>
                <p class="my-4 font-semibold">¡Te esperamos!</p>
            </div>
            <button
                slot="button"
                class="uppercase text-white bg-blue-600 hover:bg-blue-800 py-3 px-5 mt-4 mb-4 focus:outline-none focus:shadow-outline"
                @click="verDetalleReserva"
            >
                Ver Reserva
            </button>
        </sweet-modal>
    </div>
</template>

<script>
import moment from "moment";
import Loader from "./mixins/Loader";
import YamahaApi from "../Api";
import Utilities from "../utilities";
import { SweetModal } from "sweet-modal-vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import VueScrollTo from "vue-scrollto";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import PrettyCheck from "pretty-checkbox-vue/check";
import PrettyRadio from "pretty-checkbox-vue/radio";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
    name: "AgendarReserva",
    mixins: [Loader],
    components: {
        FormWizard,
        TabContent,
        PrettyCheck,
        PrettyRadio,
        VueCtkDateTimePicker,
        SweetModal,
    },
    computed: {
        precioTotal() {
            return this.form.servicios.reduce(
                (total, s) => total + s.detalle.valor,
                0
            );
        },
        duracionTotal() {
            return this.form.servicios.reduce(
                (total, s) => total + s.detalle.duracion,
                0
            );
        },
        minDate() {
            return moment().add(1, "days").format("YYYY-MM-DD");
        },
        rutDv() {
            return this.form.rut + "-" + Utilities.calcularDv(this.form.rut);
        },
        iframeHtml() {
            return this.form.distribuidor.link_mapa.replace(/\\"/gi, "");
        },
        listaIncluye() {
            let incluye = [];

            this.form.servicios.forEach((s) => {
                incluye = incluye.concat(s.detalle.incluye.split("\n"));
            });

            return incluye.filter(
                (value, index, list) => list.indexOf(value) === index
            );
        },
    },
    data() {
        return {
            Api: null,
            motos: [],
            comunas: [],
            servicios: [],
            categorias: [],
            regiones: [],
            distribuidores: [],
            slugDistribuidor: null,
            esPresupuestoQuery: false,
            esPresupuesto: false,
            // Configuración del Date & Time picker
            datepicker: {
                disabledWeekly: [0], // Por defecto deshabilita el domingo
                enabledHours: [],
            },
            query: {
                region_id: null,
                distribuidor_id: null,
            },
            // Datos del formulario
            form: {
                region_id: null,
                region: null,
                distribuidor_id: null,
                distribuidor: null,
                moto_id: null,
                moto: null,
                patente: null,
                chasis: null,
                anio: null,
                kilometraje: null,
                comentarios: null,
                servicios: [],
                nombre: null,
                apellido: null,
                rut: null,
                email: null,
                telefono: null,
                comuna: null,
                comuna_id: null,
                region_cliente: null,
                region_id_cliente: null,
                direccion: null,
                fecha_reserva: null,
                hora_reserva: null,
            },
            // Errores de ajax o de formulario
            errors: {
                response: null,
                form: { "tab-1": {}, "tab-2": {}, "tab-3": {} },
            },
            // Reserva de respuesta al crear
            reserva: null,
        };
    },
    watch: {
        "form.fecha_reserva"(newValue) {
            if (newValue) {
                this.obtenerHorariosDisponibles(newValue);
            }
            this.clearElementError("tab-2", "fecha_reserva");
        },
        "form.hora_reserva"() {
            this.clearElementError("tab-2", "hora_reserva");
        },
    },
    methods: {
        abrirModal(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].open();
            }
        },
        cerrarModal(ref) {
            if (this.$refs[ref]) {
                this.$refs[ref].close();
            }
        },
        parseDate(fecha, formato = "DD-MM-YYYY") {
            return moment(fecha, formato);
        },
        cambiarMoto() {
            const moto = this.motos.find((m) => m.id === this.form.moto_id);

            this.form.servicios = [];

            if (moto) {
                this.form.moto = moto;

                // Se auto selecciona el servicio de presupuesto
                if (this.esPresupuestoQuery) {
                    // Solo muestra los presupuestos
                    this.servicios = moto.servicios.filter(
                        (s) =>
                            s.tipo === "PRESUPUESTO" &&
                            s.distribuidor_id === this.form.distribuidor_id
                    );

                    const presupuestoIndex = this.servicios.findIndex(
                        (s) => s.tipo === "PRESUPUESTO"
                    );

                    if (presupuestoIndex !== -1) {
                        const servicio = this.servicios[presupuestoIndex];
                        this.agregarServicio(servicio);
                    }
                } else {
                    this.servicios = moto.servicios.filter(
                        (s) =>
                            s.tipo !== "PRESUPUESTO" &&
                            s.distribuidor_id === this.form.distribuidor_id
                    );
                }

                this.clearElementError("tab-1", "moto_id");
            } else {
                this.form.moto = null;
                this.servicios = [];
            }
        },
        cambiarRegionCliente() {
            this.form.region = this.regiones.find(
                (m) => m.id === this.form.region_id_cliente
            );
            this.clearElementError("tab-3", "region_id_cliente");
            this.obtenerComunas();
        },
        cambiarComuna() {
            this.form.comuna = this.comunas.find(
                (m) => m.id === this.form.comuna_id
            ).nombre;
            this.clearElementError("tab-3", "comuna_id");
        },
        cambiarRegion(distribuidor_id) {
            this.form.region = this.regiones.find(
                (r) => r.id === this.form.region_id
            );

            this.obtenerDistribuidores(distribuidor_id);
            this.clearElementError("tab-2", "region_id");
        },
        cambiarDistribuidor() {
            this.form.distribuidor = this.distribuidores.find(
                (d) => d.id === this.form.distribuidor_id
            );

            // Limpia la fecha seleccionada (si hay) y el listado de horarios disponibles
            this.form.fecha_reserva = null;
            this.datepicker.enabledHours = [];
            this.form.moto_id = null;
            this.form.moto = null;
            this.servicios = [];

            this.clearElementError("tab-2", "distribuidor_id");
            this.obtenerMotos();
        },
        obtenerMotos() {
            this.load();
            this.motos = [];
            this.categorias = [];

            this.Api.instance
                .request({
                    url: this.Api.endpointPrefix + "/motos",
                    method: "get",
                    params: {
                        servicios: true,
                        distribuidor: this.form.distribuidor_id,
                    },
                })
                .then((response) => {
                    if (response.data) {
                        this.motos = response.data;
                        this.popularCategorias();
                        //this.form.moto_id = this.motos[0].id;
                        this.cambiarMoto();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        obtenerComunas() {
            this.load();

            this.Api.instance
                .request({
                    url: this.Api.endpointPrefix + "/comunas",
                    method: "get",
                    params: { region: this.form.region_id_cliente },
                })
                .then((response) => {
                    if (response.data) {
                        this.comunas = response.data;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        popularCategorias() {
            this.motos.forEach((moto) => {
                let catIndex = this.categorias.findIndex(
                    (c) => c.id === (moto.categoria.id || -1)
                );

                try {
                    if (catIndex === -1) {
                        let nombre = this.nombreCategoria(moto.categoria);
                        let cat = {
                            id: moto.categoria.id,
                            nombre: nombre,
                            padre: null,
                            motos: [moto],
                        };

                        if (cat.padre) {
                            cat.padre = {
                                id: moto.categoria.padre.id,
                                nombre: moto.categoria.padre.nombre,
                            };
                        }
                        this.categorias.push(cat);
                    } else {
                        this.categorias[catIndex].motos.push(moto);
                    }
                } catch (err) {
                    console.log(err);
                }
            });
        },
        ordenarCategorias(arr) {
            return arr.slice().sort((a, b) => a.nombre.localeCompare(b.nombre));
        },
        nombreCategoria(categoria) {
            if (!categoria.padre) {
                return categoria.nombre;
            }

            return categoria.padre.nombre + " - " + categoria.nombre;
        },
        obtenerRegiones(region_id, distribuidor_id) {
            this.load();

            this.Api.instance
                .request({
                    url: this.Api.endpointPrefix + "/regiones",
                    method: "get",
                    params: {
                        "order_by[nombre]": "ASC",
                    },
                })
                .then((response) => {
                    if (response.data && response.data.data) {
                        this.regiones = response.data.data;

                        // Si se especificó la región, se limita el selector a esa región
                        if (this.query.region_id !== null) {
                            this.regiones = this.regiones.filter(
                                (r) => r.id === this.query.region_id
                            );
                        }

                        if (region_id) {
                            this.form.region_id = region_id;
                        } else {
                            this.form.region_id = this.regiones[0].id;
                        }
                        this.cambiarRegion(distribuidor_id);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        obtenerDistribuidores(distribuidor_id) {
            this.load();

            this.form.distribuidor = null;
            this.form.distribuidor_id = null;

            this.Api.instance
                .request({
                    url: this.Api.endpointPrefix + "/distribuidores",
                    method: "get",
                    params: {
                        region: this.form.region_id,
                        agendamiento: true,
                        "order_by[nombre]": "ASC",
                    },
                })
                .then((response) => {
                    if (response.data && response.data.data) {
                        this.distribuidores = response.data.data;

                        // Si se especificó el distribuidor, se limita el selector a ese distribuidor
                        if (this.query.distribuidor_id !== null) {
                            this.distribuidores = this.distribuidores.filter(
                                (d) => d.id === this.query.distribuidor_id
                            );
                        }

                        if (
                            distribuidor_id ||
                            this.distribuidores.length === 1
                        ) {
                            this.form.distribuidor_id = distribuidor_id
                                ? distribuidor_id
                                : this.distribuidores[0].id;

                            this.cambiarDistribuidor();
                        }
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        obtenerHorariosDisponibles(fecha) {
            this.load();

            this.form.hora_reserva = null;
            this.datepicker.enabledHours = [];

            const desde = moment(fecha, "DD-MM-YYYY");
            this.esPresupuesto =
                this.form.servicios.findIndex(
                    (s) => s.tipo === "PRESUPUESTO"
                ) !== -1;

            this.Api.instance
                .request({
                    url:
                        this.Api.endpointPrefix +
                        "/agendamiento/verificar/horarios_fecha",
                    method: "get",
                    params: {
                        fecha: desde.format("YYYY-MM-DD"),
                        duracion: this.duracionTotal,
                        distribuidor: this.form.distribuidor_id,
                        es_presupuesto: this.esPresupuesto,
                    },
                })
                .then((response) => {
                    if (response.data && response.data) {
                        this.datepicker.enabledHours = response.data;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        agregarServicio(servicio) {
            this.form.servicios = [];
            this.form.servicios.push(servicio);

            this.form.fecha_reserva = null;
            this.form.hora_reserva = null;
            this.datepicker.enabledHours = [];

            this.clearElementError("tab-1", "servicios");

            setTimeout(() => {
                const radio = document.querySelector(
                    "div#servicio-" + servicio.id + " > input[type='radio']"
                );
                radio.checked = true;
            }, 500);
        },
        addTabError(tabIndex, element, error) {
            error = error || "Campo requerido";
            this.errors.form[tabIndex][element] = error;
        },
        clearTabErrors(tabIndex) {
            this.errors.form[tabIndex] = {};
        },
        elementHasError(tabIndex, element) {
            return (
                this.errors.form[tabIndex] &&
                this.errors.form[tabIndex][element]
            );
        },
        clearElementError(tabIndex, element) {
            if (
                this.errors.form[tabIndex] &&
                this.errors.form[tabIndex][element] &&
                (this.form[element] ||
                    ((typeof this.form[element] === "string" ||
                        Array.isArray(this.form[element])) &&
                        this.form[element].length > 0))
            ) {
                delete this.errors.form[tabIndex][element];
            }
        },
        validarMotoServicios() {
            const tabIndex = "tab-1";
            this.clearTabErrors(tabIndex);

            if (!this.form.moto_id) {
                this.addTabError(tabIndex, "moto_id");
            }

            if (!this.form.patente) {
                this.addTabError(tabIndex, "patente");
            }

            if (!this.form.anio) {
                this.addTabError(tabIndex, "anio");
            }

            if (!this.form.kilometraje) {
                this.addTabError(tabIndex, "kilometraje");
            }

            if (this.form.servicios.length === 0) {
                this.addTabError(tabIndex, "servicios");
            }

            return Object.keys(this.errors.form[tabIndex]).length === 0;
        },
        validarFechaReserva() {
            const tabIndex = "tab-2";
            this.clearTabErrors(tabIndex);

            if (!this.form.region_id) {
                this.addTabError(tabIndex, "region_id");
            }

            if (!this.form.distribuidor_id) {
                this.addTabError(tabIndex, "distribuidor_id");
            }

            if (!this.form.fecha_reserva) {
                this.addTabError(tabIndex, "fecha_reserva");
            }

            if (!this.form.hora_reserva) {
                this.addTabError(tabIndex, "hora_reserva");
            }

            return Object.keys(this.errors.form[tabIndex]).length === 0;
        },
        validarDatosPersonales() {
            const tabIndex = "tab-3";
            this.clearTabErrors(tabIndex);

            if (!this.form.nombre) {
                this.addTabError(tabIndex, "nombre");
            }

            if (!this.form.apellido) {
                this.addTabError(tabIndex, "apellido");
            }

            if (!this.form.rut) {
                this.addTabError(tabIndex, "rut");
            } else if (!this.validarRut(this.form.rut)) {
                this.addTabError(
                    tabIndex,
                    "rut",
                    "Por favor, ingrese un RUT válido"
                );
            }

            if (!this.form.email) {
                this.addTabError(tabIndex, "email");
            } else if (!this.validarEmail(this.form.email)) {
                this.addTabError(
                    tabIndex,
                    "email",
                    "Por favor, ingrese un e-mail válido"
                );
            }

            if (!this.form.region_id_cliente) {
                this.addTabError(tabIndex, "region_id_cliente");
            }

            if (!this.form.comuna_id) {
                this.addTabError(tabIndex, "comuna_id");
            }

            if (!this.form.direccion) {
                this.addTabError(tabIndex, "direccion");
            }

            if (!this.form.telefono) {
                this.addTabError(tabIndex, "telefono");
            }

            return Object.keys(this.errors.form[tabIndex]).length === 0;
        },
        validarEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },
        limpiarRut(event) {
            const target = event.target;
            target.value = target.value.replace(/[^\d\-k]+/gi, "");
        },
        validarRut(rut) {
            const aRut = rut.split("-");

            if (aRut.length !== 2) return false;

            let dv = aRut[1];
            dv = isNaN(dv) ? dv.toLowerCase() : parseInt(dv);

            return this.calcularDv(aRut[0]) === dv;
        },
        calcularDv(T) {
            let M = 0,
                S = 1;
            for (; T; T = Math.floor(T / 10))
                S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
            return S ? S - 1 : "k";
        },
        agendarReserva() {
            this.load();

            this.reserva = null;
            this.errors.response = null;

            let fecha_inicio = this.parseDate(
                this.form.fecha_reserva,
                "DD-MM-YYYY"
            );
            fecha_inicio =
                fecha_inicio.format("YYYY-MM-DD") +
                " " +
                this.form.hora_reserva;

            let data = {
                region_id: this.form.region_id,
                distribuidor_id: this.form.distribuidor_id,
                moto_id: this.form.moto_id,
                patente: this.form.patente,
                chasis: this.form.chasis,
                anio: this.form.anio,
                kilometraje: this.form.kilometraje,
                comentarios: this.form.comentarios,
                nombre: this.form.nombre,
                apellido: this.form.apellido,
                rut: this.form.rut,
                email: this.form.email,
                telefono: this.form.telefono,
                region_id_cliente: this.form.region_id_cliente,
                comuna_id: this.form.comuna_id,
                direccion: this.form.direccion,
                fecha_inicio: fecha_inicio,
                servicios: this.form.servicios.map((s) => s.id),
            };

            this.Api.instance
                .request({
                    url: this.Api.endpointPrefix + "/agendamiento/reserva",
                    method: "post",
                    data: data,
                })
                .then((response) => {
                    if (response.data && response.data.created) {
                        this.reserva = response.data.reserva;
                        this.abrirModal("modalReservaCreada");
                    } else if (
                        response.data &&
                        response.data.created === false
                    ) {
                        this.errors.response = response.data.message;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.errors.response = `En estos momentos no podemos atender su solicitud (Código YHA-${error.response.status})`;
                    }
                })
                .then(() => {
                    this.loadComplete();
                });
        },
        verDetalleReserva() {
            if (this.reserva) {
                this.$router.push({
                    path: "detalle-reserva/" + this.reserva.id,
                });
            }

            this.cerrarModal("modalReservaCreada");
        },
    },
    created() {
        this.Api = new YamahaApi("BO");
    },
    mounted() {
        this.esPresupuestoQuery =
            this.$route.query.presupuesto === "true" ||
            this.$route.query.presupuesto === true;

        this.query.region_id = Number(this.$route.query.region) || null;
        this.query.distribuidor_id =
            Number(this.$route.query.distribuidor) || null;

        this.esPresupuesto = this.esPresupuestoQuery;

        // Metropolitana y YamaImport Las Condes por defecto
        let distribuidorDefault = 32;
        let regionDefault = 13;

        if (location.search.includes("misano")) {
            distribuidorDefault = 9;
        }

        // Distribuidor desde la URL
        if (this.query.distribuidor_id) {
            distribuidorDefault = this.query.distribuidor_id;
        }

        // Región desde la URL
        if (this.query.region_id) {
            regionDefault = this.query.region_id;
        }

        this.obtenerRegiones(regionDefault, distribuidorDefault);

        setTimeout(() => {
            VueScrollTo.scrollTo("#cmbMotos", 500, {
                easing: "ease-in",
            });
        }, 500);
    },
};
</script>
